import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IComponentTag } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useCreateComponentTag = () => {
  return useMutation({
    mutationFn: createComponentTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.componentTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewComponentTagWithComponentCount.invalidateAll(),
      );
    },
  });
};

const createComponentTag = async (payload: Partial<IComponentTag>) => {
  const request = {
    name: payload.name,
  };

  const response = await requestCCApi({
    url: `/componentTags`,
    method: 'POST',
    data: { data: request },
  });

  return response;
};
